import { render, staticRenderFns } from "./promotionItem.vue?vue&type=template&id=5a3c1723&scoped=true"
import script from "./promotionItem.vue?vue&type=script&lang=js"
export * from "./promotionItem.vue?vue&type=script&lang=js"
import style0 from "./promotionItem.vue?vue&type=style&index=0&id=5a3c1723&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c1723",
  null
  
)

export default component.exports